import { cva } from 'class-variance-authority';

const switchLabelBaseStyles = [
  'cursor-pointer',
  'disabled:cursor-not-allowed',
  'select-none',
];

const switchLabelStylesSAG = cva([
  ...switchLabelBaseStyles,
  'text-[#4C4C68]',
  'peer-hover:text-[#000028]',
  'hover:text-[#000028]',
  'peer-checked:text-[#000028]',
  'peer-disabled:text-[#7D8099]',

  // Dark mode
  'dark:text-[#B3B3BE]',
  'dark:peer-hover:text-[#FFFFFF]',
  'dark:hover:text-[#FFFFFF]',
  'dark:peer-checked:text-[#FFFFFF]',
  'dark:peer-disabled:text-[#737389]',
]);

const switchLabelStylesSHS = cva([
  ...switchLabelBaseStyles,
  'text-[#1A1A1A]',
  'peer-hover:text-[#1A1A1A]',
  'hover:text-[#1A1A1A]',
  'peer-checked:text-[#1A1A1A]',
  'peer-disabled:text-[#A3A3A3]',

  // Dark mode
  'dark:text-[#E6E6E6]',
  'dark:peer-hover:text-[#E6E6E6]',
  'dark:hover:text-[#E6E6E6]',
  'dark:peer-checked:text-[#E6E6E6]',
  'dark:peer-disabled:text-[#5C5C5C]',
]);

export { switchLabelStylesSAG, switchLabelStylesSHS };
